<template>
  <validation-observer
    ref="resourceSaveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="addMultipleChoiceAnswerModal"
      ref="addMultipleChoiceAnswerModalRef"
      body-class="position-static"
      centered
      size="xl"
      title="Thêm đáp án cho câu hỏi trắc nghiệm"
      :no-close-on-backdrop="true"
      @hide="onHide"
    >
      <b-row>
        <b-col cols="12">
          <b-form-group label-for="isCorrect">
            <b-form-checkbox
              v-model="multipleTemp"
              value="1"
              unchecked-value="0"
            >
              Câu hỏi có nhiều đáp án
            </b-form-checkbox>
          </b-form-group>
          <b-form
            ref="formRef"
            :style="{height: trHeight}"
          >
            <b-row
              v-for="(item, index) in createChoiceAnswersReqDtos"
              :id="item.id"
              :key="item.id"
              ref="row"
            >
              <b-col md="2">
                <b-form-group label-for="name">
                  <template v-slot:label>
                    Tên đáp án <span class="text-danger">*</span>
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Tên đáp án"
                    rules="required"
                  >
                    <b-form-input
                      id="name"
                      v-model="item.name"
                      name="name"
                      placeholder="Nhập tên đáp án"
                      :state="getElementState(errors)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="8">
                <b-form-group label-for="content">
                  <template v-slot:label>
                    Nội dung <span class="text-danger">*</span>
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Nội dung"
                    rules="required"
                  >
                    <b-form-input
                      id="content"
                      v-model="item.content"
                      name="content"
                      placeholder="Nội dung"
                      :state="getElementState(errors)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label-for="orderNo">
                  <template v-slot:label>
                    Thứ tự đáp án <span class="text-danger">*</span>
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Thứ tự đáp án"
                    rules="required"
                  >
                    <b-form-input
                      id="orderNo"
                      v-model="item.orderNo"
                      name="orderNo"
                      placeholder="Thứ tự đáp án"
                      :state="getElementState(errors)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label-for="score">
                  <template v-slot:label>
                    Điểm cho đáp án <span class="text-danger">*</span>
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Điểm cho đáp án"
                    rules="required"
                  >
                    <b-form-input
                      id="score"
                      v-model="item.score"
                      name="score"
                      type="number"
                      placeholder="Điểm cho đáp án"
                      :state="getElementState(errors)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                md="2"
              >
                <b-form-group label-for="score">
                  <b-form-checkbox
                    v-model="item.isCorrect"
                    class="mt-3"
                    value="1"
                    unchecked-value="0"
                  >
                    Là đáp án đúng
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col
                lg="2"
                md="2"
                class="mb-50"
              >
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-0 mt-md-2"
                  @click="removeItem(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Xóa</span>
                </b-button>
              </b-col>
              <b-col cols="12">
                <hr>
              </b-col>
            </b-row>
          </b-form>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            @click="repeatAgain"
          >
            <feather-icon
              icon="PlusIcon"
              class="mr-25"
            />
            <span>Thêm mới</span>
          </b-button>
        </b-col>
      </b-row>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :disabled="invalid || createChoiceAnswersReqDtos.length === 0"
            variant="primary"
            class="mr-1"
            @click="onSave"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('addMultipleChoiceAnswerModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        no-wrap
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BButton, BCol, BForm, BFormCheckbox, BFormGroup, BFormInput, BModal, BOverlay, BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightTransition } from '@core/mixins/ui/transition'
import vSelect from 'vue-select'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import { required } from '@core/utils/validations/validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'AddMultipleChoiceAnswerResource',
  directives: {
    Ripple,
  },
  components: {
    BFormCheckbox,
    BFormInput,
    BModal,
    BOverlay,
    BButton,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [heightTransition],
  props: {
    qbQuestionId: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      multipleTemp: 0,
      createChoiceAnswersReqDtos: [{
        id: 1,
        name: '',
        content: '',
        isCorrect: 0,
        multiple: 0,
        score: 0,
        orderNo: 1,
      }],
      nextId: 2,
      required,
    }
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    ...mapActions({
      createResource: 'qbMultipleChoiceAnswer/create',
    }),
    repeatAgain() {
      this.createChoiceAnswersReqDtos.push({
        id: this.nextId += this.nextId,
        name: '',
        content: '',
        isCorrect: 0,
        multiple: this.multipleTemp,
        score: 0,
        orderNo: 1,
      })
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.createChoiceAnswersReqDtos.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.addMultipleChoiceAnswerModalRef.scrollHeight)
      })
    },
    onHide() {
      this.createChoiceAnswersReqDtos = [{
        id: 1,
        name: '',
        content: '',
        isCorrect: false,
        multiple: 0,
        score: 0,
        orderNo: 1,
      }]
      this.nextId = 2
      this.multipleTemp = 0
    },
    async onSave() {
      const valid = this.$refs
        .resourceSaveFormRef
        .validate()
      if (valid && this.createChoiceAnswersReqDtos.length > 0) {
        this.isLoading = true
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.createChoiceAnswersReqDtos.length; i++) {
          this.createChoiceAnswersReqDtos[i].multiple = this.multipleTemp
        }
        try {
          const response = await this.createResource({
            id: this.qbQuestionId,
            createChoiceAnswersReqDtos: this.createChoiceAnswersReqDtos,
          })
          if (response) {
            const { isSuccessful, message } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              this.$emit('succeed')
              this.$bvModal.hide('addMultipleChoiceAnswerModal')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
